
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class DismantlingReturnItemsGrid extends Serenity.EntityGrid<DismantlingReturnItemsRow, any> {
        protected getColumnsKey() { return 'Production.DismantlingReturnItems'; }
        protected getDialogType() { return DismantlingReturnItemsDialog; }
        protected getIdProperty() { return DismantlingReturnItemsRow.idProperty; }
        protected getInsertPermission() { return DismantlingReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return DismantlingReturnItemsRow.localTextPrefix; }
        protected getService() { return DismantlingReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}